import './categories.scss'
import {images} from '../../constants'

const Categories = () => {
  return (
    <section className="app_top_category">
      <h3>TOP CATEGORIES</h3>
      <div className="app_categories_div">
        <div className="app_categories_item">
          <img src={images.NaturalFertility} alt='natural-fertility'/>
          <p>Men & Women Fertility</p>
        </div>
        <div className="app_categories_item">
          <img src={images.Consultation} alt='consultation'/>
          <p>Tele Consultation</p>
        </div>
        <div className="app_categories_item">
          <img src={images.Shop} alt='shop'/>
          <p>Innovative Products</p>
        </div>
        <div className="app_categories_item">
          <img src={images.NurseryDesign} alt='nursery-design'/>
          <p>Nursery Design</p>
        </div>
        <div className="app_categories_item">
          <img src={images.MentalWellness} alt='mental-wellness'/>
          <p>Yoga & Fitness</p>
        </div>
      </div>
    </section>
  )
}

export default Categories